import React from 'react';
import {useTranslation} from 'react-i18next';
import {StyledNetSuiteBillsPage} from './StyledNetSuiteBillsPage';
import DashboardPageTransition from '../../components/animations/DashboardPageTransition';
import BalancePageHeader from '../../components/pages/TransactionsPage/BalancePageHeader/BalancePageHeader';
import PageDocumentDetails from '../../components/PageDocumentDetails/PageDocumentDetails';
import BillsTabs from '../../components/pages/NetSuiteBillsPage/BillsTabs';

const NetSuiteBillsPage = () => {
  const [t] = useTranslation('main');

  const title = t('pageTitles.vendorBills');

  return (
    <StyledNetSuiteBillsPage>
      <PageDocumentDetails title={title} />
      <BalancePageHeader breadcrumbs={[{ title }]} />
      <DashboardPageTransition>
        <BillsTabs />
      </DashboardPageTransition>
    </StyledNetSuiteBillsPage>
  );
}

export default NetSuiteBillsPage;
